<template>
  <div class="sub-panel">
    <drawer-inner
      show-back
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot />
    </drawer-inner>
  </div>
</template>

<script>
import DrawerInner from './drawer-inner.vue'

export default {
  components: {
    DrawerInner
  },
}
</script>

<style lang="scss">
  @import "./common.scss";

  .sub-panel {
    @include panel;
  }
</style>